export function consumerSummaryText(): JSX.Element {
  return <div className="Text">No items created yet.</div>;
}
